<template>
  <div>
    <v-card
      @click="triggerUpload"
      align="center"
      width="250"
      height="250"
      v-if="!value"
    >
      <br /><br /><br />
      <v-btn
        color="primary"
        v-if="!videoIsProcessing && !videoIsUploading"
        outline
      >
        {{ label }}
      </v-btn>
      <v-progress-circular
        v-if="videoIsUploading"
        :rotate="-90"
        :size="100"
        :width="15"
        :value="progress"
        color="primary"
      >
        {{ progress }}
      </v-progress-circular>
      <div v-if="videoIsProcessing">
        <v-progress-linear :indeterminate="true"></v-progress-linear>
        {{ progressText }}
      </div>
      <input
        :ref="refName"
        v-show="false"
        type="file"
        class="form-control"
        enctype="multipart/form-data"
        name="file_data"
        @change="onFileChange($event.target.name, $event.target.files)"
      />
      <br />
      <small class="red--text" v-if="videoIsUploading || videoIsProcessing"
        >Do not refresh the page</small
      >
    </v-card>
    <v-divider class="pa-4"></v-divider>
    <ConfirmationDialog
      v-if="resetDialog"
      :dialog="resetDialog"
      @confirm="setUrl(null)"
      @cancel="resetDialog = false"
    ></ConfirmationDialog>
    <template v-if="value">
      <v-card-title class="title"
        >{{ previewTitle }}
        <v-spacer></v-spacer>
        <v-btn @click="resetDialog = true" color="red" outline>Remove</v-btn>
      </v-card-title>
      <v-layout class="pt-4" row>
        <v-flex xs10>
          <v-text-field
            @input="$emit('input', $event)"
            :value="value"
            :label="label"
            type="text"
            disabled
          ></v-text-field>
        </v-flex>
        <v-flex xs2 class="text-md-right">
          <v-btn
            color="primary"
            dark
            class="mx-0"
            @click.stop="showPreview = true"
            >{{ $t("screener.btn.preview") }}</v-btn
          >
        </v-flex>
      </v-layout>
    </template>

    <!-- Preview Player -->
    <v-container class="pa-0" v-if="showPreview">
      <v-dialog max-width="55vmin" v-model="showPreview" persistent>
        <v-card>
          <v-card-title>
            <div class="title">{{ previewTitle }}</div>
            <v-spacer></v-spacer>
            <v-btn
              small
              dark
              icon
              color="grey"
              @click="showPreview = false"
              class="mx-0"
            >
              <v-icon small>$vuetify.icons.rms_close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <ScreenerPlayer :movie="value"></ScreenerPlayer>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import VimeoUpload from "vimeo-upload";
import ScreenerPlayer from "@/components/screener/Player";
import ConfirmationDialog from "@/components/dialogBox/Confirmation";
export default {
  props: ["value", "previewTitle", "label", "refName"],
  name: "VimeoUploader",
  data() {
    return {
      resetDialog: false,
      videoIsUploading: false,
      videoIsProcessing: false,
      progress: 0,
      showPreview: false,
      progressText: "Transcoding",
    };
  },

  components: {
    ScreenerPlayer,
    ConfirmationDialog,
  },

  methods: {
    triggerUpload() {
      this.$refs[this.refName].click();
    },

    onFileChange(fieldName, fileList) {
      var self = this;
      var files = fileList[0];
      this.videoIsUploading = true;

      new VimeoUpload({
        name: files.name.replace(/\.[^/.]+$/, ""),
        file: files,
        token: this.DEFINES.VIMEO_ACCESS_TOKEN,
        onError: function(data) {
          alert("<strong>Error</strong>: " + JSON.parse(data).error, "danger");
        },
        onProgress: function(data) {
          var progress = data.loaded / data.total;
          self.progress = Math.floor(progress * 100);
        },
        onComplete: function(videoId, index) {
          self.videoIsUploading = false;
          self.videoIsProcessing = true;
          self.getFieldsFromVimeo(videoId, "transcode");
        },
      }).upload();
    },

    getFieldsFromVimeo(videoId, field) {
      var _this = this;
      var xhr = new XMLHttpRequest();
      xhr.open(
        "Get",
        "https://api.vimeo.com/me/videos/" + videoId + "?fields=" + field,
        true
      );
      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + this.DEFINES.VIMEO_ACCESS_TOKEN
      );
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.onload = function(e) {
        if (e.target.status == 200) {
          var response = JSON.parse(e.target.responseText);
          switch (field) {
            case "transcode":
              var status = response.transcode.status;
              if (status == "complete") {
                _this.getFieldsFromVimeo(videoId, "files");
              } else {
                _this.progressText = "Transcode status : " + status;
                // console.log(status);
                setTimeout(function() {
                  _this.getFieldsFromVimeo(videoId, field);
                }, 8000);
              }
              break;
            case "files":
              _this._fetchVimeoFiles(videoId, response);
              break;
            default:
              _this.$store.dispatch("app/showMessage", {
                message: _this.$t("screener.pre_roll.process_failed"),
                color: "error",
              });
              break;
          }
        }
      };
      xhr.send();
    },

    _fetchVimeoFiles(videoId, response) {
      var _this = this;
      // if files are not available
      // than continue fetching the files
      if (response.files.length == 0) {
        setTimeout(function() {
          _this.getFieldsFromVimeo(videoId, "files");
        }, 10000);
        return;
      }

      // find hlsQuality
      var hlsFile = response.files.find((file) => file.quality == "hls");

      // if hlsQualtiy is unavailable
      // than continue fetching the files
      if (hlsFile == undefined) {
        setTimeout(function() {
          _this.getFieldsFromVimeo(videoId, "files");
        }, 10000);
      } else {
        // else setUrl
        _this.setUrl(hlsFile.link_secure);
      }
    },

    async setUrl(url) {
      try {
        this.$emit("setUrl", url);
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: this.$t("media.save_failed"),
          color: "error",
        });
      } finally {
        this.videoIsProcessing = false;
        this.resetDialog = false;
      }
    },
  },
};
</script>
